import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'
import { Button } from 'components/atoms/button'

interface RSVPConfirmationModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	eventName?: string
	loading?: boolean
	onConfirm: () => void
}

export function RSVPConfirmationModal({
	open,
	setOpen,
	eventName,
	loading = false,
	onConfirm,
}: RSVPConfirmationModalProps) {
	return (
		<ConfirmationModal title="RSVP" open={open} setOpen={setOpen} loading={loading} blur hideCloseButton={false}>
			<div>
				<div className="mb-8">{eventName}</div>
				<div className="mb-16">Will you be attending this event?</div>
				<div className="flex justify-between gap-6">
					<Button variant="primary" fullWidth onClick={onConfirm} disabled={loading}>
						{loading && <FontAwesomeIcon icon={['fas', 'spinner']} size="lg" spin className="mr-1" />}
						Yes
					</Button>
					<Button variant="primary" fullWidth onClick={() => setOpen(false)} disabled={loading}>
						No
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface RSVPConfirmationModalManagedProps {
	eventName?: string
	loading?: boolean
	onConfirm: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'rsvp-confirmation': RSVPConfirmationModalManagedProps
	}
}

export function ManagedRSVPConfirmationModal({
	onClose,
	onConfirm,
	...rest
}: RSVPConfirmationModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<RSVPConfirmationModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm(); handleClose() }}
			{...rest}
		/>
	)
}
